import React, { Component } from 'react';

export default function ChildProfileMainText({title, text}) {
  if (!text) {
    return null;
  }

  return(
    <div id="msc-main-content" className="ChildProfileMainText" style={{ maxWidth: "960px", margin: "0 auto" }}>
      { title ? <h1>{title}</h1> : "" }
      { text ? <p className="rflgroup-text">{text}</p> : "" }
    </div>
  );
}